var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ab5cab86"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "control has-icons-left" };
const _hoisted_2 = ["placeholder"];
const _hoisted_3 = { class: "icon is-small is-left" };
const _hoisted_4 = {
    key: 0,
    class: "list"
};
const _hoisted_5 = ["onClick"];
import { ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TypeAheadWithQuery',
    props: {
        getMatches: { type: Function },
        limit: {},
        placeholder: {},
        icon: {},
        labelField: {},
        getLabel: { type: Function }
    },
    emits: ["itemSelected"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const getLabel = (item) => {
            if (props.labelField)
                return item[props.labelField];
            if (props.getLabel)
                return props.getLabel(item);
            return item.name;
        };
        let searchTerm = ref('');
        let searchResults = ref([]);
        let resultsIdx = ref(0);
        let numQueries = 0;
        let queryPending = false;
        watch([searchTerm], () => __awaiter(this, void 0, void 0, function* () {
            if (searchTerm.value === '') {
                searchResults.value = [];
                return;
            }
            if (!queryPending) {
                queryPending = true;
                setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                    var _a;
                    queryPending = false;
                    const queryIdx = ++numQueries;
                    const matches = yield props.getMatches(searchTerm.value);
                    if (resultsIdx.value < queryIdx) {
                        searchResults.value = matches.slice(0, (_a = props.limit) !== null && _a !== void 0 ? _a : 10);
                        resultsIdx.value = queryIdx;
                    }
                }), 300);
            }
        }));
        const selectItem = (item) => {
            searchTerm.value = '';
            emit('itemSelected', item);
        };
        const typeAheadInputElem = ref(null);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("p", _hoisted_1, [
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "search",
                        ref_key: "typeAheadInputElem",
                        ref: typeAheadInputElem,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(searchTerm) ? (searchTerm).value = $event : searchTerm = $event)),
                        placeholder: _ctx.placeholder,
                        class: "input"
                    }, null, 8, _hoisted_2), [
                        [_vModelText, _unref(searchTerm)]
                    ]),
                    _createElementVNode("span", _hoisted_3, [
                        _createElementVNode("i", {
                            class: _normalizeClass(_ctx.icon)
                        }, null, 2)
                    ])
                ]),
                (_unref(searchResults).length)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchResults), (item) => {
                            return (_openBlock(), _createElementBlock("li", {
                                key: item.name,
                                onClick: ($event) => (selectItem(item)),
                                class: "list-item"
                            }, _toDisplayString(getLabel(item)), 9, _hoisted_5));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
